import {ChangeDetectionStrategy, Component, Input} from '@angular/core';

@Component({
	selector: 'app-status-order-providers',
	templateUrl: './status-order-providers.html',
	styleUrl: './status-order-providers.scss',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class StatusOrderProvidersComponent {
	@Input() img!: string;
	@Input() online: boolean | null;
}
